const I18n = require('i18n-js');

export default function trixEditor() {
  document.addEventListener('trix-change', function(event) {
    const editor = event.target;
    editor.style.height = 'auto';  // To expand to content
  }); 

  //TODO: Implement after Rails 2.7 upgrade
   document.addEventListener('trix-initialize', (event) => {
    const editor = event.target; 
    
    //Auto-size on load to avoid overflow
    editor.style.height = 'auto'; 
    
    // Remove file upload button
    const fileButton = event.target.toolbarElement.querySelector('.trix-button-group--file-tools');
    if (fileButton) {
      fileButton.remove();
    }
 // Reset
    //editor.style.height = editorElement.scrollHeight + 'px';    
//     console.log("Wbiłem sobie do trix initialize");
//     console.log(I18n.t('trix.bold'));

//     const toolbar = event.target.toolbarElement;
    
//     // Map button classes to i18n keys (adjust as needed)
//     const buttons = {
//       'trix-button--icon-bold': 'trix.bold',
//       'trix-button--icon-italic': 'trix.italic',
//       'trix-button--icon-strike': 'trix.strike',
//       'trix-button--icon-link': 'trix.link',
//       'trix-button--icon-quote': 'trix.quote',
//       'trix-button--icon-code': 'trix.code',
//       // Add more for bullet, number, etc.
//     };

//     Object.keys(buttons).forEach((className) => {
//       const button = toolbar.querySelector(`.${className}`);
//       if (button) {
//         const key = buttons[className];
//         button.setAttribute('title', I18n.t(key));  // Assumes you have I18n.js setup
//       }
//     });
   });  
}
